export const formOrderObjFromCart = (data = null) => {
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    const entityDetails = data?.itemDetail?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: environmentDetails?.sector || null,
        environment: environmentDetails?.environment || null,
        appRegion: environmentDetails?.applicationRegion || null,
        department: catalogConfig?.department || null,
        // region: environmentDetails?.region || null,
        // regionDisplayName: { label: environmentDetails?.region || null, value: environmentDetails?.region || null },
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        ...(environmentDetails?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
        }),
        awsAccountId: catalogConfig?.awsAccountId || null,
        bucketName: catalogConfig?.bucketName || null,
        storageClass: catalogConfig?.storageClass || null,
        serverSideEncryption: catalogConfig?.serverSideEncryption || null,
        appSupportTeamName: catalogConfig?.s3BucketUsedBy,
        s3BucketKeyEnabled: catalogConfig?.isS3BucketKeyEnabled === true ? 'yes' : 'no',
        versioning: catalogConfig?.isVersioningEnabled === true ? 'yes' : 'no',
        blockPublicAccess: catalogConfig?.isBlockPublicAccessEnabled === true ? 'yes' : 'no',
        s3ObjectLockEnabled: catalogConfig?.isS3ObjectLockEnabled === true ? 'yes' : 'no',
        isS3BucketFolderRequired: catalogConfig?.isBucketFolderRequired === true ? 'yes' : 'no',
        s3Folders: catalogConfig?.bucketFolder || [],
        isReplication: environmentDetails?.environment === 'Production' && catalogConfig?.isReplication === true ? 'yes' : 'no',
        ...(environmentDetails?.environment === 'Production' &&
            catalogConfig?.isReplication === true && {
                replicatedS3BucketName: catalogConfig?.replicationBucketName,
                replicatedRegionCode: environmentDetails?.replicationCrossRegion,
                replicatedRegion: environmentDetails?.replicationCrossRegion,
            }),
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        entityDetails: { ...entityDetails },
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const entityDetails = data?.itemDetail?.entityDetails || null;
    return {
        appProfile: catalogConfig?.applicationService || null,
        applicationName: catalogConfig?.applicationName || null,
        appShortName: catalogConfig?.appShortName || null,
        sector: environmentDetails?.sector || null,
        environment: environmentDetails?.environment || null,
        appRegion: environmentDetails?.applicationRegion || null,
        department: catalogConfig?.department || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        ...(environmentDetails?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
        }),
        awsAccountId: catalogConfig?.awsAccountId || null,
        bucketName: catalogConfig?.bucketName || null,
        storageClass: catalogConfig?.storageClass || null,
        serverSideEncryption: catalogConfig?.serverSideEncryption || null,
        appSupportTeamName: catalogConfig?.s3BucketUsedBy,
        s3BucketKeyEnabled: catalogConfig?.isS3BucketKeyEnabled === true ? 'yes' : 'no',
        versioning: catalogConfig?.isVersioningEnabled === true ? 'yes' : 'no',
        blockPublicAccess: catalogConfig?.isBlockPublicAccessEnabled === true ? 'yes' : 'no',
        s3ObjectLockEnabled: catalogConfig?.isS3ObjectLockEnabled === true ? 'yes' : 'no',
        isS3BucketFolderRequired: catalogConfig?.isBucketFolderRequired === true ? 'yes' : 'no',
        s3Folders: catalogConfig?.bucketFolder || [],
        isReplication: environmentDetails?.environment === 'Production' && catalogConfig?.isReplication === true ? 'yes' : 'no',
        ...(environmentDetails?.environment === 'Production' &&
            catalogConfig?.isReplication === true && {
                replicatedS3BucketName: catalogConfig?.replicationBucketName,
                replicatedRegionCode: environmentDetails?.replicationCrossRegion,
                replicatedRegion: environmentDetails?.replicationCrossRegion,
            }),
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        entityDetails: { ...entityDetails },
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetOrder = {
    // Application Section
    applicationName: null,
    appShortName: null,
    appProfile: null,
    entityDetails: null,
    sector: null,
    sectorDetails: null,
    department: null,
    appRegion: null,
    environment: null,
    landingZoneDetails: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,

    // Resource Section
    awsAccountId: null,
    awsAccount: null,
    bucketName: null,
    storageClass: null,
    appSupportTeamName: null,
    serverSideEncryption: null,
    blockPublicAccess: 'no',
    versioning: 'no',
    s3BucketKeyEnabled: 'no',
    s3ObjectLockEnabled: 'no',
    isS3BucketFolderRequired: 'no',
    s3Folders: [],

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const costPayload = ({ order = [], catalogCode, catalogServiceId }) => {
    const payload = {
        ...(catalogServiceId && { catalogServiceId }),
        cloudProvider: order?.cloudProvider,
        cloudService: order?.cloudService,
        catalogServiceCode: catalogCode,
        catalogType: order?.catalogType,
        sector: order?.sector,
        quantity: 1,
        catalogConfig: {
            applicationService: order?.appProfile,
            awsAccountId: order?.awsAccountId,
            bucketName: order?.bucketName,
            storageClass: order?.storageClass,
            serverSideEncryption: order?.serverSideEncryption,
            s3BucketUsedBy: order?.appSupportTeamName,
            isS3BucketKeyEnabled: order?.s3BucketKeyEnabled === 'yes',
            isVersioningEnabled: order?.versioning === 'yes',
            isBlockPublicAccessEnabled: order?.blockPublicAccess === 'yes',
            isS3ObjectLockEnabled: order?.s3ObjectLockEnabled === 'yes',
            environmentDetails: {
                costCenter: order?.hCode,
                region: order?.landingZoneDetails?.region,
                environment: order?.environment,
                sector: order?.sector,
            },
            tags: {
                Environment: order?.environment,
                Application: order?.appProfile,
            },
            type: catalogCode,
        },
    };
    return payload;
};

export const validateS3FolderName = (folderName) => {
    if (!folderName || folderName.trim() === '') {
        return { isValid: false, message: 'S3 Folder name is required' };
    }

    const trimmedName = folderName.trim();

    // Check if folder name is empty (no empty folder names allowed)
    if (trimmedName === '') {
        return { isValid: false, message: 'Empty folder names are not allowed' };
    }

    // Check for consecutive slashes (not allowed)
    if (trimmedName.includes('//')) {
        return { isValid: false, message: 'Consecutive slashes (//) are not allowed' };
    }

    // Check length - individual folder name should not exceed reasonable length
    // (Total object key can be up to 1024 characters, but for individual folder names we limit to 255)
    if (trimmedName.length > 255) {
        return { isValid: false, message: 'Folder name cannot exceed 255 characters' };
    }

    // Check for valid characters: A-Z, a-z, 0-9, ., -, ~, _, =, :, / (single forward slash allowed)
    // Forward slash (/) is used as path separator for hierarchical folder structures
    const validCharRegex = /^[A-Za-z0-9.\-~_=:/]+$/;
    if (!validCharRegex.test(trimmedName)) {
        return {
            isValid: false,
            message:
                'Invalid characters. Only A-Z, a-z, 0-9, periods (.), hyphens (-), tildes (~), underscores (_), equal signs (=), colons (:), forward slashes (/) are allowed',
        };
    }

    // Check path segments (separated by slashes) - cannot exceed 254 segments
    const pathSegments = trimmedName.split('/').filter((segment) => segment !== '');
    if (pathSegments.length > 254) {
        return { isValid: false, message: 'Too many path segments. Maximum 254 path segments allowed' };
    }

    // Avoid ending with dot (.) or forward slash (/) as it can lead to unexpected behavior
    if (trimmedName.endsWith('.')) {
        return { isValid: false, message: 'Folder name should not end with a period (.)' };
    }

    if (trimmedName.endsWith('/')) {
        return { isValid: false, message: 'Folder name should not end with a forward slash (/)' };
    }

    // Avoid starting with certain characters that might cause issues
    if (trimmedName.startsWith('.')) {
        return { isValid: false, message: 'Folder name should not start with a period (.)' };
    }

    if (trimmedName.startsWith('/')) {
        return { isValid: false, message: 'Folder name should not start with a forward slash (/)' };
    }

    return { isValid: true, message: '' };
};
